const Embed = require('./embed/embed')

document.addEventListener("DOMContentLoaded",function(){
  Embed.init()
})
